import { toast } from 'react-toastify';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function ProspectSinupUrl({ signupUrl }) {
  const copySignupUrl = () => {
    navigator.clipboard.writeText(signupUrl);
    toast.success('URL copied to clipboard');
  };

  return (
    <Row className="mt-5 mb-2 align-items-center">
      <Col md={2} className="bo-same-line">
        <Form.Label>Signup URL:</Form.Label>
      </Col>
      <Col md={9} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="signupUrl"
          id="signupUrl"
          placeholder="signupUrl"
          value={signupUrl || 'Save to generate...'}
          disabled
        />
      </Col>
      <Col md={1} className="bo-same-line">
        <Button className="m-0 p-0 bo-button-inline-link" onClick={copySignupUrl}>
          Copy
        </Button>
      </Col>
    </Row>
  );
}

export default ProspectSinupUrl;
